module.exports = __webpack_public_path__ + "img/logo.9d18dad7.png";